import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/query-keys';
import { mcpOAuthApi, type McpGrantScope } from '@/lib/api';

/**
 * Disconnect an app in `scope` — POST /mcp/oauth/grants/:id/revoke (`users.manage`)
 * or /mcp/oauth/grants/own/:id/revoke (`data.view`, TDEV-1234) — then refresh both lists.
 */
export function useRevokeMcpGrant(scope: McpGrantScope) {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) => mcpOAuthApi.revokeGrant(scope, id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mcpOAuth.grantsAll });
    },
  });
}
